import { messageCommentOfPostFragment } from "Post/modules/PostFragments";
import { gql } from "lib/apolloClient";
import {
  attachmentFragment,
  resolvedFieldValueFragment,
} from "modules/CommonFragments";
import { projectUserFragment } from "Projects/modules/ProjectFragments";

export const processJournalFragment = {
  basicDetails: gql`
    fragment processJournalItem on Post {
      id
      title
      description
      attachments {
        ...attachmentItem
        displaySequence
      }
      createdAt
      createdBy {
        ...userItem
      }
      students {
        edges {
          node {
            ...userItem
          }
        }
      }
      elementPYP {
        id
        value
        fieldUID
        parentType
        resolvedMinimalTree {
          ...resolvedMinimalTreeItem
        }
      }
      isStarred
      isRead
      comments {
        totalCount
        unreadCount
        unreadCountV2
        edges: messageEdges(first: 1) {
          node {
            ...messageItem
          }
        }
        unreadCommentsEdges: unreadMessageEdges {
          node {
            ...messageItem
          }
        }
      }
    }
    ${projectUserFragment.basicUser}
    ${attachmentFragment.attachment}
    ${resolvedFieldValueFragment.resolvedMinimalTree}
    ${messageCommentOfPostFragment.message}
  `,
};
